import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

export interface NotificacaoAcaoCriada   { acaoId: string; titulo: string; responsavel: string; momento: string; }
export interface NotificacaoStatusAlterado { acaoId: string; titulo: string; statusAnterior: string; statusNovo: string; momento: string; }
export interface NotificacaoPrazoUrgente { acaoId: string; titulo: string; diasRestantes: number; responsavel: string; momento: string; }

@Injectable({ providedIn: 'root' })
export class NotificacaoService {
  private hub!: signalR.HubConnection;

  acaoCriada$     = new Subject<NotificacaoAcaoCriada>();
  statusAlterado$ = new Subject<NotificacaoStatusAlterado>();
  prazoUrgente$   = new Subject<NotificacaoPrazoUrgente>();

  constructor(private authService: AuthService) {}

  iniciar(): void {
    const hubUrl = environment.apiUrl.replace('/api', '') + '/hubs/notificacoes';
    this.hub = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, { accessTokenFactory: () => this.authService.getToken() ?? '' })
      .withAutomaticReconnect()
      .build();

    this.hub.on('AcaoCriada',     (d: NotificacaoAcaoCriada)     => this.acaoCriada$.next(d));
    this.hub.on('StatusAlterado', (d: NotificacaoStatusAlterado) => this.statusAlterado$.next(d));
    this.hub.on('PrazoUrgente',   (d: NotificacaoPrazoUrgente)   => this.prazoUrgente$.next(d));

    this.hub.start().catch(err => console.error('[SignalR]', err));
  }

  parar(): void { this.hub?.stop(); }
}